import { ROUTES as e } from "./routes.mjs";
import { PAGE_TITLE as t } from "./pageTitles.mjs";
import { matchPath as n } from "react-router-dom";
//#region src/pageTitleMatch.ts
var r = (e) => e.split("/").filter(Boolean).reduce((e, t) => t.startsWith(":") ? e + (t.endsWith("?") ? 0 : 1) : e + 2, 0), i = (e, t, n) => {
	let a = e, o = t;
	for (let e of Object.keys(a)) {
		let t = a[e];
		typeof t == "string" ? n.push({
			path: t,
			title: o[e],
			score: r(t)
		}) : i(t, o[e], n);
	}
	return n;
}, a = i(e, t, []).sort((e, t) => t.score - e.score), o = (e) => {
	for (let t of a) if (n(e, {
		path: t.path,
		exact: !0
	})) return t.title;
};
//#endregion
export { o as titleForPathname };
